import React, { useCallback, useState } from "react";
import { 
  AppBar, 
  Typography, 
  Toolbar, 
  Button, 
  Box,
  Chip,
  Menu,
  MenuItem,
  Divider
} from "@material-ui/core";
import { makeStyles, alpha } from "@material-ui/core/styles";
import { Link, NavLink, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Users from "../Users";
import Produits from "../Produits";
import Depenses from "../Clients";
import { useNavigate } from "react-router";
import ProduitService from "../../services/ProduitService";
import { Alert } from "../../components/Alert";
import Commandes from "../commandes";
import LocalHospitalIcon from '@material-ui/icons/LocalHospital';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import PersonIcon from '@material-ui/icons/Person';
import AssessmentIcon from '@material-ui/icons/Assessment';
import PeopleIcon from '@material-ui/icons/People';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import BusinessIcon from '@material-ui/icons/Business';
import GroupIcon from '@material-ui/icons/Group';
import BarChartIcon from '@material-ui/icons/BarChart';
import Statistiques from "../Statistiques";
import Protected from "../../Protected";
import NotFound from "../NotFound";
import UserProfile from "../../components/UserProfile";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  appBar: {
    background: 'linear-gradient(135deg, #226D68 0%, #2a8c82 100%)',
    boxShadow: '0 4px 20px rgba(34, 109, 104, 0.3)',
    backdropFilter: 'blur(10px)',
  },
  toolbar: {
    minHeight: 70,
    padding: theme.spacing(0, 3),
  },
  logo: {
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none',
    color: 'white',
    fontWeight: 700,
    fontSize: '1.5rem',
    '&:hover': {
      color: '#f26522',
    },
  },
  logoIcon: {
    fontSize: 36,
    marginRight: theme.spacing(1),
    color: '#f26522',
  },
  navButtons: {
    display: 'flex',
    gap: theme.spacing(1),
    marginLeft: theme.spacing(4),
  },
  navButton: {
    color: 'white',
    fontWeight: 500,
    fontSize: '0.9rem',
    textTransform: 'none',
    borderRadius: 25,
    padding: theme.spacing(1, 2),
    transition: 'all 0.3s ease',
    '&:hover': {
      backgroundColor: '#f26522',
      color: 'white',
      transform: 'translateY(-1px)',
      boxShadow: '0 4px 15px rgba(242, 101, 34, 0.4)',
    },
  },
  activeNavButton: {
    backgroundColor: '#f26522 !important', // Force la couleur avec !important
    color: 'white !important',
    border: `1px solid #f26522 !important`,
    boxShadow: '0 4px 15px rgba(242, 101, 34, 0.4) !important',
    transform: 'translateY(-1px)',
    '&:hover': {
      backgroundColor: '#f26522 !important',
      transform: 'translateY(-2px)',
      boxShadow: '0 6px 20px rgba(242, 101, 34, 0.6) !important',
    },
  },
  userSection: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    marginLeft: 'auto',
  },
  userInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    padding: theme.spacing(1, 2),
    borderRadius: 20,
    backgroundColor: alpha('#fff', 0.1),
    backdropFilter: 'blur(10px)',
    transition: 'all 0.3s ease',
    '&:hover': {
      backgroundColor: alpha('#f26522', 0.2),
      transform: 'translateY(-1px)',
    },
  },
  userChip: {
    color: 'white',
    backgroundColor: '#f26522',
    fontWeight: 600,
    '&:hover': {
      backgroundColor: '#f26522',
      transform: 'scale(1.05)',
    },
    transition: 'all 0.3s ease',
  },
  logoutButton: {
    color: 'white',
    backgroundColor: alpha('#ff4757', 0.2),
    borderRadius: 20,
    padding: theme.spacing(1, 2),
    textTransform: 'none',
    fontWeight: 500,
    '&:hover': {
      backgroundColor: '#ff4757',
      transform: 'translateY(-1px)',
      boxShadow: '0 4px 15px rgba(255, 71, 87, 0.4)',
    },
    transition: 'all 0.3s ease',
  },
  notificationButton: {
    color: 'white',
    backgroundColor: alpha('#fff', 0.1),
    borderRadius: '50%',
    width: 40,
    height: 40,
    '&:hover': {
      backgroundColor: '#f26522',
      transform: 'scale(1.1)',
    },
    transition: 'all 0.3s ease',
  },
  badge: {
    '& .MuiBadge-badge': {
      backgroundColor: '#f26522',
      color: 'white',
      fontSize: '0.7rem',
      fontWeight: 'bold',
    },
  },
  menuPaper: {
    borderRadius: 12,
    marginTop: theme.spacing(1),
    background: 'linear-gradient(135deg, #226D68 0%, #2a8c82 100%)',
    color: 'white',
    boxShadow: '0 8px 32px rgba(34, 109, 104, 0.3)',
  },
  menuItem: {
    '&:hover': {
      backgroundColor: '#f26522',
      color: 'white',
    },
    transition: 'all 0.3s ease',
  },
  linkStyle: {
    textDecoration: "none",
    color: "inherit",
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  icon: {
    fontSize: 20,
  },
  navIcon: {
    fontSize: 20,
    color: 'inherit',
  },
}));

const Dashboard = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const location = useLocation(); // Ajout de useLocation pour détecter la route active
  const user = useSelector((state) => state.auth);
  const speudo = user?.speudo;
  const userRole = user?.rol;

  const [stocks, setStocks] = useState([]);
  const [openAlert, setOpenAlert] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [notificationAnchor, setNotificationAnchor] = useState(null);
  const [profileOpen, setProfileOpen] = useState(false);


  const handleProfileOpen = () => {
    setProfileOpen(true);
    handleMenuClose(); // Fermer le menu
  };
  
  const handleProfileClose = () => {
    setProfileOpen(false);
  };

  const handleSignOut = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    navigate("/login");
  };

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleNotificationOpen = (event) => {
    setNotificationAnchor(event.currentTarget);
  };

  const handleNotificationClose = () => {
    setNotificationAnchor(null);
  };

  const getStocks = useCallback(() => {
    ProduitService.getNullStocks()
      .then((res) => {
        setStocks(res.data);
      })
      .catch(err => {
        console.log(err);
      });
  }, []);

  // useEffect(() => {
  //   getStocks();
  // }, []);

  // Fonction pour vérifier si une route est active
  const isActive = (path) => {
    return location.pathname === `/dashboard/${path}` || 
           (location.pathname === '/dashboard' && path === 'produits');
  };

  // Définition des éléments de menu
  const menuItems = [
    { 
      path: "produits", 
      label: "Produits", 
      icon: <BusinessIcon className={classes.navIcon} />, 
      protected: false 
    },
    { 
      path: "clients", 
      label: "Clients", 
      icon: <PeopleIcon className={classes.navIcon} />, 
      protected: false 
    },
    { 
      path: "commandes", 
      label: "Commandes", 
      icon: <ShoppingCartIcon className={classes.navIcon} />, 
      protected: false 
    },
  ];

  // Ajouter les menus admin seulement si l'utilisateur est admin
  if (userRole === "admin") {
    menuItems.push(
      { 
        path: "users", 
        label: "Utilisateurs", 
        icon: <GroupIcon className={classes.navIcon} />, 
        protected: true 
      },
      { 
        path: "statistiques", 
        label: "Statistiques", 
        icon: <BarChartIcon className={classes.navIcon} />, 
        protected: true 
      }
    );
  }

  return (
    <>
      <div className={classes.root}>
        <AppBar position="fixed" className={classes.appBar}>
          <Toolbar className={classes.toolbar}>
            {/* Logo */}
            <Link to="/dashboard" className={classes.logo}>
              <LocalHospitalIcon className={classes.logoIcon} />
              <Typography variant="h5" component="span" style={{ fontWeight: 700 }}>
                SN-STOCK
              </Typography>
            </Link>

            {/* Navigation Buttons */}
            <Box className={classes.navButtons}>
              {menuItems.map((item) => {
                const active = isActive(item.path);
                return (
                  <Button
                    key={item.path}
                    component={NavLink}
                    to={item.path}
                    className={`${classes.navButton} ${active ? classes.activeNavButton : ''}`}
                    startIcon={item.icon}
                    // Configuration spécifique pour NavLink
                    style={{
                      backgroundColor: active ? '#f26522' : 'transparent',
                      color: active ? 'white' : 'white',
                    }}
                  >
                    {item.label}
                  </Button>
                );
              })}
            </Box>

            {/* User Section */}
            <Box className={classes.userSection}>
              {/* Notifications */}
              {/* <Badge 
                badgeContent={stocks.length} 
                color="error" 
                className={classes.badge}
              >
                <IconButton 
                  className={classes.notificationButton}
                  onClick={handleNotificationOpen}
                >
                  <NotificationsIcon />
                </IconButton>
              </Badge> */}

              {/* User Info */}
              <Box className={classes.userInfo}>
                <PersonIcon style={{ fontSize: 20, opacity: 0.8 }} />
                <Box>
                  <Typography variant="subtitle2" style={{ fontWeight: 600 }}>
                    {speudo}
                  </Typography>
                  <Chip 
                    label={userRole?.toUpperCase()} 
                    size="small" 
                    className={classes.userChip}
                    onClick={handleMenuOpen}
                  />
                </Box>
              </Box>

              {/* Logout Button */}
              <Button
                className={classes.logoutButton}
                onClick={handleSignOut}
                startIcon={<ExitToAppIcon />}
              >
                Déconnexion
              </Button>
            </Box>

            {/* User Menu */}
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
              classes={{ paper: classes.menuPaper }}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
            >
              <MenuItem className={classes.menuItem} onClick={handleProfileOpen}>
                <Box className={classes.linkStyle}>
                  <PersonIcon className={classes.icon} />
                  Profil Utilisateur
                </Box>
              </MenuItem>
              <MenuItem className={classes.menuItem} onClick={handleMenuClose}>
                <Box className={classes.linkStyle}>
                  <AssessmentIcon className={classes.icon} />
                  Tableau de Bord
                </Box>
              </MenuItem>
              <Divider style={{ backgroundColor: alpha('#fff', 0.2) }} />
              <MenuItem className={classes.menuItem} onClick={handleSignOut}>
                <Box className={classes.linkStyle}>
                  <ExitToAppIcon className={classes.icon} />
                  Déconnexion
                </Box>
              </MenuItem>
            </Menu>

            {/* Notifications Menu */}
            {/* <Menu
              anchorEl={notificationAnchor}
              open={Boolean(notificationAnchor)}
              onClose={handleNotificationClose}
              classes={{ paper: classes.menuPaper }}
            >
              <MenuItem className={classes.menuItem}>
                <Typography variant="body2" style={{ fontWeight: 600 }}>
                  Alertes Stock ({stocks.length})
                </Typography>
              </MenuItem>
              <Divider style={{ backgroundColor: alpha('#fff', 0.2) }} />
              {stocks.length > 0 ? (
                stocks.slice(0, 5).map((stock, index) => (
                  <MenuItem key={index} className={classes.menuItem}>
                    <Typography variant="caption">
                      Stock faible: {stock.nom}
                    </Typography>
                  </MenuItem>
                ))
              ) : (
                <MenuItem className={classes.menuItem}>
                  <Typography variant="caption">
                    Aucune alerte
                  </Typography>
                </MenuItem>
              )}
            </Menu> */}
          </Toolbar>
        </AppBar>
        
        {/* Add padding to account for fixed AppBar */}
        <Toolbar />
      </div>

      <Routes>
        <Route index element={<Produits />} />
        <Route 
          path="users" 
          element={
            <Protected requiredRole="admin">
              <Users />
            </Protected>
          } 
        />
        <Route path="produits" element={<Produits />} />
        <Route path="clients" element={<Depenses />} />
        <Route path="commandes" element={<Commandes />} />
        <Route 
          path="statistiques" 
          element={
            <Protected requiredRole="admin">
              <Statistiques />
            </Protected>
          } 
        />
        <Route path="*" element={<NotFound />} />
      </Routes>

      {openAlert && <Alert setOpen={setOpenAlert} data={stocks} />}
      <UserProfile open={profileOpen} onClose={handleProfileClose} />

    </>
  );
};

export default Dashboard;